export default "__VITE_ASSET__1f8f25d4__"